module.exports = __webpack_public_path__ + "img/Turntable.e9268b98.png";